import React, { useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from 'react-icons/md';

const SidebarModule = ({ title, icon: Icon, children, isCollapsed }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="sidebar-module">
            <button
                className={`module-header ${isOpen ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <Icon />
                {!isCollapsed && (
                    <>
                        <span className="module-title">{title}</span>
                        {isOpen ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
                    </>
                )}
            </button>
            <div className={`module-content ${isOpen ? 'open' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default SidebarModule;